// Общий роутер. Экраны сюда не дописываются: они приходят из src/pages/**/routes.tsx (см. registry.ts).

import { Navigate, createBrowserRouter, type RouteObject } from 'react-router-dom'

import { AppShell } from '@/components/layout/AppShell'
import { MORE_PATH } from '@/components/layout/BottomNav'

import { MorePage } from './MorePage'
import { NotFoundPage } from './NotFoundPage'
import { buildNav, collectPages, type CollectedPages, type PageModule } from './registry'
import { RequireAuth } from './RequireAuth'

const pageModules = import.meta.glob<PageModule>('../pages/**/routes.tsx', { eager: true })

export const pages: CollectedPages = collectPages(pageModules)

/** Дерево маршрутов: публичные → (вход) → без оболочки и в оболочке. */
export function buildRouteTree(collected: CollectedPages): RouteObject[] {
  const nav = buildNav(collected.nav)
  const declared = new Set(collected.routes.map((r) => r.path))
  // Адрес раздела без своего экрана ведёт на первую вкладку: /settings → /settings/security.
  const sectionRedirects: RouteObject[] = Object.entries(nav.children)
    .filter(([parent, children]) => !declared.has(parent) && children.length > 0)
    .map(([parent, children]) => ({
      path: parent,
      element: <Navigate to={children[0]!.path} replace />,
    }))

  return [
    ...collected.publicRoutes,
    {
      element: <RequireAuth />,
      children: [
        ...collected.bareRoutes,
        {
          element: <AppShell nav={nav} />,
          children: [
            ...collected.routes,
            ...sectionRedirects,
            { path: MORE_PATH, element: <MorePage /> },
            { path: '*', element: <NotFoundPage /> },
          ],
        },
      ],
    },
  ]
}

export function createAppRouter() {
  return createBrowserRouter(buildRouteTree(pages))
}
